import { Select, Space } from 'antd';
import styled, { css } from 'styled-components';
import { CombinationValueType, PointerIcon, CustomCss, DimensionTitleType } from './types';

export const BackBtn = styled.span`
  display: flex;
  align-items: center;
  margin: 17px 23px 14px;
  column-gap: 6px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #818181;
  cursor: pointer;
`;

export const ConfigWrapper = styled.div`
  padding: 0 17px 140px;
  overflow-y: scroll;
  height: 100%;
`;

export const CombinationValue = styled.div<CombinationValueType>`
  box-sizing: border-box;
  border-radius: 3px;
  min-width: 127px;
  font-weight: 400;
  line-height: 16px;
  font-size: 16px;
`;

export const CardinalityValue = styled(CombinationValue)`
  font-size: 12px;
  border: none;
  color: #4c4c4c;
`;

export const CombinationValueText = styled.div`
  margin-bottom: 8px;
`;

export const CombinationText = styled.p`
  display: inline-block;
  margin: 0 3px 0 0;
  line-height: 0.4;
  cursor: pointer;

  &:hover {
    ${CombinationValue} {
      border-color: #ff6961;
      color: #ff6961;
    }
  }
`;

export const TopIconSection = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const ActiveAlertCount = styled.span`
  color: #fff;
  background: #f5222d;
  font-size: 12px;
  padding: 4px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 6px;
`;

export const CombinationWrapper = styled.div<{
  highlightDimension: string;
  isBeingDeleted: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-right: 17px;
  border-radius: 8px;
  padding: 8px 20px 8px 8px;
  background: ${({ highlightDimension }) =>
    highlightDimension ? `${highlightDimension}50` : '#F6FFED'};
  border: 1px solid
    ${({ highlightDimension }) => (highlightDimension ? `${highlightDimension}` : '#52C41A')};
  opacity: ${({ isBeingDeleted }) => (isBeingDeleted ? 0.4 : 1)};
`;

export const CombinationListWrapper = styled.div<CustomCss>`
  display: flex;
  padding: 10px 0;
  flex-wrap: wrap;
  row-gap: 10px;

  ${({ customCss }) => customCss}
`;

export const DimensionTitle = styled.p<DimensionTitleType>`
  display: inline-block;
  font-size: 16px;
  line-height: 22px;
  font-weight: ${({ isPopup }) => (isPopup ? 700 : 600)};
  color: ${({ isPopup }) => (isPopup ? '#4A4A4A' : '#1F1F1F')};
  margin-right: 10px;
  min-width: max-content;
`;

export const ScanTitle = styled.p`
  display: inline-block;
  font-size: 16px;
  color: #1f1f1f;
`;

export const AllDimensionList = styled.ul`
  list-style-type: none;

  & li {
    position: relative;
    padding-left: 51px;
  }

  & li::before {
    content: '';
    position: absolute;
    left: 21px;
    top: 0;
    border-bottom: 2px dashed #979797;
    border-radius: 0 0 0 16px;
    width: 41px;
    height: 13px;
  }

  & li::after {
    content: '';
    position: absolute;
    left: 21px;
    bottom: -12px;
    border-left: 2px dashed #979797;
    width: 0;
    height: 105%;
  }

  & li:last-child::after {
    display: none;
  }

  & li:last-child::before {
    border-left: 2px dashed #979797;
  }
`;

export const PointerIconRing = styled.div<PointerIcon>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ margin }) => margin};
  width: 24px;
  height: 24px;
  background: ${({ isSubPointer }) => !isSubPointer && 'red'};
  border-radius: ${({ isSubPointer }) => !isSubPointer && '50%'};

  > svg {
    width: 24px;
    height: 24px;
    fill: #979797;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;

export const dimensionCustomCss = css`
  &::before {
    content: '';
    position: relative;
    top: 36px;
    left: -32px;
    height: 58px;
    border-left: 2px dashed #979797;
  }
`;

export const AddDimensionBtn = styled.span<{ isAdminUser: boolean }>`
  display: grid;
  place-content: center;
  min-width: 32px;
  height: 34px;
  border: 1px solid ${({ isAdminUser }) => (isAdminUser ? '#0046ff' : '#afafaf')};
  border-radius: 5px;
  margin: 10px 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: ${({ isAdminUser }) => (isAdminUser ? '#0046ff' : '#afafaf')};
  cursor: ${({ isAdminUser }) => (isAdminUser ? 'pointer' : 'not-allowed')};
`;

export const AddDimensionWrapper = styled.div`
  position: relative;

  /* left: 30px; */
  margin-right: 10px;
`;

export const DimensionWrapper = styled.div<{ displayAddDimension: boolean }>`
  position: relative;
  padding-left: ${({ displayAddDimension }) => (displayAddDimension ? 80 : 36)}px;
  min-height: 90px;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 23px 20px;
`;

export const ConfigHeaderText = styled.p`
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
`;

export const AddPopupWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 32px 20px 22px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 6px rgb(0 0 0 / 25%);
  border-radius: 6px;
`;

export const SelectWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  margin: 8px 0;
`;

export const PrimaryBtn = styled.button`
  background: #266fff;
  border-radius: 5px;
  border: 1px solid #266fff;
  padding: 6px 11px;
  color: #fff;

  &:disabled {
    opacity: 0.4;
  }
`;

export const StyledSelect = styled(Select)`
  width: 250px;
`;

export const StyledSpace = styled(Space)`
  font-size: 18px;
  cursor: pointer;
  height: 12px;
`;

export const StyledSelector = styled.div`
  margin-top: -5px;
  margin-left: -5px;
  background-color: #f8fafb;
  width: fit-content;
  border-bottom: 1px solid #e5e9ec;
  border-right: 1px solid #e5e9ec;
  border-top-left-radius: 6px;

  .ant-select-selection-item {
    font-weight: 500;
  }
`;
export const SelectGroupLabel = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
